<h2 mat-dialog-title>Login</h2>
<mat-dialog-content>
    <form [formGroup]="form">
        <mat-form-field appearance="outline">
            <mat-label>Username</mat-label>
            <input matInput formControlName="username" />
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>Password</mat-label>
            <input matInput type="password" formControlName="password" />
        </mat-form-field>
        @if(error()){
        <p>{{ error() }}</p>
        }
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="onLogin().subscribe()">Login</button>
</mat-dialog-actions>
